import React, { useState } from 'react'
const status = process.env.REACT_APP_MINT

const ConnectButton = ({ metamask, provider, setIsOpen, isOpen }) => {
  if(status === "NO"){
    return (<button className="btn btn-lg bg-info mint-button-padding rounded rounded-pill fs-2 text-white">SOON</button>)
  }

  if(status === "YES")
  return(
    provider.address ? 
    <button className="btn btn-lg bg-info mint-button-padding rounded rounded-pill fs-2 text-white" 
    onClick={() => setIsOpen(!isOpen)}>MINT</button>
    :
    <button className="btn btn-lg bg-warning mint-button-padding rounded rounded-pill fs-2 text-white" onClick={metamask}>Connect</button>
  )

}

export default function One({metamask, provider, isOpen, setIsOpen}) {

  const scroll = (id) => {
    document.getElementById(id).scrollIntoView({behavior: 'smooth'})
  }
  return (
    <div className="vh-100 page-1 p-0 m-0 d-flex flex-column gap-5">
    <div className="d-flex justify-content-between px-5 py-3">
      <div>
        <img src="/img/logo.png" alt="Dawdlers Logo" />
      </div>
      <div className="d-flex gap-5 text-white text-uppercase fs-4 align-items-center justify-content-center">
        <span onClick={() => scroll("roadmap")} style={{ cursor: 'pointer' }}>roadmap</span>
        <span onClick={() => scroll("team")} style={{ cursor: 'pointer' }}>team</span>
        <span onClick={() => scroll("faq")} style={{ cursor: 'pointer' }}>faq</span>
        <span onClick={() => scroll("contact")} style={{ cursor: 'pointer' }}>contact us</span>
      </div>
      {<ConnectButton metamask={metamask} provider={provider} setIsOpen={setIsOpen} isOpen={isOpen} />}
    </div>
  </div>
  )
}
